export default function Users() {
    return <h2>Users</h2>;
}